import FormattedMessage from 'I18n/components/FormattedMessage';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { BreezeRegenerateIcon, RemoveIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import useCloneTracker from '../../../../hooks/useCloneTracker';
import ReportingAIAssistantInsightsDisclaimer from '../../fullPage/report-ai-assistant-insights/ReportingAIAssistantInsightsDisclaimer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AIReportSummaryFooterWithActions = ({
  appUsageTracker,
  setIsSummaryExpanded,
  forceRender
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      marginBlockStart: "400",
      children: [/*#__PURE__*/_jsx(AIButton, {
        size: "xs",
        usageTracker: tracker,
        onClick: forceRender,
        use: "tertiary",
        showBreezeIcon: false,
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(BreezeRegenerateIcon, {
            size: "200"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.singleReportViewer.AIReportSummary.buttons.refresh"
          })]
        })
      }), /*#__PURE__*/_jsx(AIButton, {
        size: "xs",
        usageTracker: tracker,
        onClick: () => setIsSummaryExpanded(false),
        use: "tertiary",
        showBreezeIcon: false,
        children: /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          gap: "100",
          children: [/*#__PURE__*/_jsx(RemoveIcon, {
            size: "100"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.singleReportViewer.AIReportSummary.buttons.close"
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(ReportingAIAssistantInsightsDisclaimer, {})
    })]
  });
};
export default AIReportSummaryFooterWithActions;